import { createSlice } from "@reduxjs/toolkit";
import { getAppsData } from './thunk';
export const initialState : any = {
  appsData: null,
  error: ""
};
const DashboardSlice = createSlice({
  name: 'Dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAppsData.pending, (state) => {
      state.appsData = null;
      state.error = "";
    });
    builder.addCase(getAppsData.fulfilled, (state, action) => {
      state.appsData = action.payload;
      state.error = "";
    });
    builder.addCase(getAppsData.rejected, (state, action) => {
      state.error = action.payload ?? action.error.message;
    });
  }
});
export default DashboardSlice.reducer;